const MAIL_TEST = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const isEmail = (string) => {
    return MAIL_TEST.test(string)
}